import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext } from 'react';
import { Form, Message } from 'semantic-ui-react';
import _get from 'lodash/get';
import _startCase from 'lodash/startCase';
import { validateFormField, createFileObjects } from './UploadFileField.utils';
import { FormFieldFileProptype } from '../../../../../types/FormField.types';
import UploadCareWidget from '../../../../UploadCareWidget';
import { DynamicFormContext } from '../../../context/DynamicFormContext';
var uploadCareKey = process.env.UPLOADCARE_PUB_KEY;
function UploadFileField(_ref) {
  var field = _ref.field;
  var _useContext = useContext(DynamicFormContext),
    componentConfigurationId = _useContext.componentConfigurationId,
    hideLabels = _useContext.hideLabels,
    isFormDisabled = _useContext.isFormDisabled,
    onChange = _useContext.onChange,
    formErrors = _useContext.formErrors,
    setFormErrors = _useContext.setFormErrors,
    clearFieldError = _useContext.clearFieldError,
    displayErrors = _useContext.displayErrors,
    formData = _useContext.formData,
    touched = _useContext.touched;
  var label = field.label,
    name = field.name,
    required = field.required,
    disabled = field.disabled,
    _field$settings = field.settings,
    settings = _field$settings === void 0 ? {} : _field$settings;
  function fileChangeHandler(files) {
    clearFieldError(name);
    onChange(null, {
      name: name,
      value: createFileObjects(files)
    });
    var error = validateFormField(field, files);
    if (error) {
      setFormErrors(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), error);
      });
    }
  }
  function getFiles() {
    return _get(formData, name, []);
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    className: "upload-file",
    disabled: isFormDisabled || disabled,
    required: required,
    name: name
  }, !hideLabels && /*#__PURE__*/React.createElement("label", null, _startCase(label)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UploadCareWidget, _extends({
    name: name,
    id: componentConfigurationId,
    publicKey: uploadCareKey,
    onFileChange: fileChangeHandler,
    files: getFiles(),
    isReset: !touched
  }, settings))), displayErrors && formErrors[name] && /*#__PURE__*/React.createElement(Message, {
    negative: true,
    size: "mini"
  }, formErrors[name]));
}
export default UploadFileField;